import React from 'react';
import { Radio, FormControlLabel, FormControl, RadioGroup } from '@mui/material';

const RadioButton = ({ radioValue, onChange, options }) => {
    return (
        <FormControl component="fieldset" sx={{ display: 'flex', flexDirection: 'row' }}>
            <RadioGroup
                sx={{ display: 'flex', flexDirection: 'row' }}
                aria-label="options"
                name="options"
                value={radioValue}
                onChange={onChange}
            >
                {options.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={
                            <Radio
                                sx={{
                                    color: radioValue === option.value ? '#000000' : '#858485',
                                    '&.Mui-checked': {
                                        color: '#000000',
                                        
                                    },
                                }}
                            />
                        }
                        label={option.label}
                        sx={{
                            fontSize: '20px',
                            fontWeight : 700,
                            color: radioValue === option.value ? '#000000' : '#858485',
                            fontFamily: 'Gotham',
                            
                        }}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default RadioButton;
